import { styled } from "@shoothill/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";
import { InductionAdminViewModel } from "../InductionAdminViewModel";
import MaterialTable from "material-table";
import { DarwinTablePageContent } from "Globals/Styles/AppStyling";
import { formatDate, formatTime } from "Utils/Format";
import { SHBox } from "Components/Box";
import { PatchedPagination } from "Components/Table/PatchedPagination";
import * as Defaults from "Globals/Defaults/TableOptions";
import { InductionAdminScaffoldingListItemModel } from "./InductionAdminScaffoldingListItemModel";
import { InductionAdminScaffoldingListViewModel } from "./InductionAdminScaffoldingListViewModel";

interface IProps {
    className?: string;
    viewModel: InductionAdminViewModel;
    inductionUserId: string;
}

const InductionAdminScaffoldingViewBase: React.FC<IProps> = (props) => {
    const { viewModel, inductionUserId } = props;
    const [scaffoldViewModel] = useState(() => new InductionAdminScaffoldingListViewModel(inductionUserId));
    // #region Code Behind

    const renderPage = () => {
        return (
            <DarwinTablePageContent>
                <MaterialTable
                    columns={[
                        {
                            title: "Date / time added",
                            field: "createdDate",
                            render: (rowData: InductionAdminScaffoldingListItemModel) => <SHBox>{`${formatDate(rowData.createdDate)} @ ${formatTime(rowData.createdDate)}`}</SHBox>,
                            defaultSort: "desc",
                        },
                        {
                            title: "Scaffold inspector",
                            field: "scaffoldInspectorName",
                        },
                        {
                            title: "No. of scaffolds",
                            field: "numberOfScaffolds",
                        },
                        {
                            title: "Last updated",
                            field: "lastUpdatedDate",
                            render: (rowData: InductionAdminScaffoldingListItemModel) => (
                                <SHBox>
                                    <SHBox>{`${formatDate(rowData.updatedDate)} @ ${formatTime(rowData.updatedDate)}`} by</SHBox>
                                    <SHBox>{rowData.updatedByName}</SHBox>
                                </SHBox>
                            ),
                        },
                    ]}
                    components={{
                        Pagination: PatchedPagination,
                        // Toolbar: (toolbarProps) => renderToolbar(toolbarProps),
                    }}
                    options={Defaults.GetDarwinTableOptions()}
                    data={scaffoldViewModel.scaffoldingListModels.slice()}
                    onRowClick={(e, rowData) => scaffoldViewModel.navigateToScaffoldInspection(rowData!)}
                    title=""
                />
            </DarwinTablePageContent>
        );
    };

    return useObserver(() => renderPage());
};

export const InductionAdminScaffoldingView = styled(InductionAdminScaffoldingViewBase)``;
